import { PrivacyModalComponent } from "./../access-data/components/privacy-modal/privacy-modal.component";
import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ContactEmailDetails } from "./contact.model";
import { APIError } from "../../shared/shared.models";
import { UtilsService } from "../../shared/utils/utils.service";
import { ContactService } from "./contact.service";
import { ModalService } from "../../shared/services/modal.service";

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit {
  onDestroy$ = new Subject();
  contactEmailDetails: ContactEmailDetails = new ContactEmailDetails();
  emailSentSuccess: boolean = false;
  apiError: APIError = new APIError();

  constructor(
    private utilsService: UtilsService,
    private contactService: ContactService,
    private modalService: ModalService
  ) {}

  ngOnInit() {
    // Default enquiry type to general
    this.contactEmailDetails.enquiryType = "general";
  }

  /**
   * Submit contact form
   */
  submitContactForm(): void {
    this.contactService
      .sendContactEmail(this.contactEmailDetails)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.emailSentSuccess = true;
        },
        (error) => {
          this.emailSentSuccess = false;
          this.apiError = this.utilsService.handleAPIError(error);
        }
      );
  }

  openPrivacyModal(): void {
    this.modalService.openModal(PrivacyModalComponent);
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
